export default __webpack_public_path__ + "static/media/share.c41c3f46.svg";